import React, { useState, useEffect } from 'react'
import Button from '../Button'
import { AlertTriangle } from '@entrata/portals-common/lib/icons'
import {
  StyledLoaderDiv,
  StyledContentDiv,
  StyledH3,
  StyledLoaderP,
} from './atoms'

import { css } from '@emotion/core'

const positionStyle = css`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`

const CatastrophicError = () => {
  const [countdown, setCountdown] = useState(10)

  useEffect(() => {
    setTimeout(() => {
      tick()
    }, 1000)
  }, [countdown])

  const tick = () => {
    if (countdown === 1) {
      reloadPage()
    } else {
      setCountdown(prevCountdown => prevCountdown - 1)
    }
  }

  const reloadPage = () => {
    window && window.location.reload()
  }

  return (
    <StyledLoaderDiv css={positionStyle}>
      <StyledContentDiv>
        <AlertTriangle size={48} />
        <StyledH3>{__('An error has occurred')}</StyledH3>
        <StyledLoaderP>
          {__(
            'An error occurred while loading this page. We have logged the error with our development team.',
          )}
        </StyledLoaderP>
        <StyledLoaderP>
          {__(
            '{%p, 0, =0{You can try reloading the application or an automatic reload will attempt in <strong># seconds</strong>.} =1{You can try reloading the application or an automatic reload will attempt in <strong># second</strong>.} other{You can try reloading the application or an automatic reload will attempt in <strong># seconds</strong>.}',
            [countdown],
          )}
        </StyledLoaderP>
        <Button appearance='action' onClick={reloadPage}>
          {__('Reload Application')}
        </Button>
      </StyledContentDiv>
    </StyledLoaderDiv>
  )
}

export default CatastrophicError
